module.exports = __webpack_public_path__ + "static/twitter-white3-74f9fa1cee8bd3b80e202f8c7e19179e.png";